var exports = {
  "O0": "MenuItemRadio.module__radioButton___OTA4d0",
  "X3": "MenuItemRadio.module__radioButtonSelected___OTA4d0",
  "EC": "MenuItemRadio.module__radioButtonUnselected___OTA4d0",
  "$l": "MenuItemRadio.module__radioIndicator___OTA4d0",
  "aT": "MenuItemRadio.module__labelContent___OTA4d0",
  "Kk": "MenuItemRadio.module__icon___OTA4d0",
  "QK": "MenuItemRadio.module__labelText___OTA4d0",
};

module.exports = exports;
